import React from 'react';
import { FormButton } from 'cx-component-library';
import EmptyState from 'views/widgets/empty-state-wrapper';

const NetworkError = () => {
  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          position: 'absolute',
          top: '12.5rem',
          right: 0,
          bottom: 'auto',
          left: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          flexDirection: 'column',
          pointerEvents: 'auto',
          zIndex: 2,
        }}
      >
        <EmptyState
          style={{ maxWidth: '60rem', margin: 'auto' }}
          heading={'There was an error trying to load the dashboard.'}
        />

        <FormButton
          label={'Retry'}
          theme='secondary'
          onClick={() => window.location.reload()}
          style={{ pointerEvents: 'auto' }}
        />
      </div>
    </div>
  );
};
export default NetworkError;
